import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import ResearchPgs from './pgs'
import ResearchPgd from './pgd'
import ResearchAzf from './azf'
import ResearchArrayPgt from './arrayPgt'

export default class index extends Component {
  render() {
    const { match } = this.props
    return (
      <Switch>
        <Route path={`${match.url}/pgs`} component={ResearchPgs} />
        <Route path={`${match.url}/pgd`} component={ResearchPgd} />
        <Route path={`${match.url}/azf`} component={ResearchAzf} />
        <Route path={`${match.url}/array-pgt`} component={ResearchArrayPgt} />
        <Redirect from="*" to={`${match.url}/pgs`} />
      </Switch>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/research/index.js